import { root } from './root';
import { MapPolyfill } from './MapPolyfill';

export const Map = root.Map || (() => MapPolyfill)();


// WEBPACK FOOTER //
// ./node_modules/rxjs/src/util/Map.ts